export type ResearchStageId = "understanding" | "searching" | "analyzing" | "synthesizing" | "finalizing";

export type ResearchStage = {
  id: ResearchStageId;
  label: string;
};

export const researchStages: ResearchStage[] = [
  { id: "understanding", label: "Understanding query" },
  { id: "searching", label: "Searching sources" },
  { id: "analyzing", label: "Reading & analyzing" },
  { id: "synthesizing", label: "Synthesizing report" },
  { id: "finalizing", label: "Finalizing" },
];

export const STAGE_SUBTITLES: Record<ResearchStageId, string> = {
  understanding: "Understanding your goal and planning the research...",
  searching: "Searching for relevant sources",
  analyzing: "Reading and analyzing sources...",
  synthesizing: "Synthesizing findings into a clear report...",
  finalizing: "Finalizing the report...",
};

export const DEFAULT_STAGE_SUBTITLE = "Preparing...";
